var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mc-select-footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-select-footer.vue